import { animated } from "@react-spring/web";
import styled from "styled-components";

export default animated(styled.footer.attrs({ component: "footer" })`
  position: relative;
  background: ${({ theme }) => theme.palette.background.paper};
  border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`);
